import { defineTextStyles } from '@chakra-ui/react';

export const textStyles = defineTextStyles({
	h1: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '36px', '48px' ],
			lineHeight:    [ '54px', '72px' ],
			fontWeight:    'bold',
			letterSpacing: 0,
		},
	},
	h2: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '30px', '40px' ],
			lineHeight:    [ '45px', '60px' ],
			fontWeight:    'bold',
			letterSpacing: 0,
		},
	},
	h3: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '26px', '32px' ],
			lineHeight:    [ '39px', '48px' ],
			fontWeight:    'bold',
			letterSpacing: 0,
		},
	},
	h4: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '22px', '28px' ],
			lineHeight:    [ '33px', '42px' ],
			fontWeight:    'bold',
			letterSpacing: 0,
		},
	},
	h5: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '20px', '24px' ],
			lineHeight:    [ '30px', '36px' ],
			fontWeight:    'bold',
			letterSpacing: 0,
		},
	},
	h6: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '18px', '20px' ],
			lineHeight:    [ '27px', '30px' ],
			fontWeight:    'bold',
			letterSpacing: 0,
		},
	},
	s1: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '30px', '40px' ],
			lineHeight:    [ '45px', '60px' ],
			fontWeight:    'semibold',
			letterSpacing: 1,
		},
	},
	s2: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '26px', '32px' ],
			lineHeight:    [ '39px', '48px' ],
			fontWeight:    'semibold',
			letterSpacing: 1,
		},
	},
	s3: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '22px', '28px' ],
			lineHeight:    [ '33px', '42px' ],
			fontWeight:    'semibold',
			letterSpacing: 1,
		},
	},
	s4: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '20px', '24px' ],
			lineHeight:    [ '30px', '36px' ],
			fontWeight:    'semibold',
			letterSpacing: 1.5,
		},
	},
	s5: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '18px', '20px' ],
			lineHeight:    [ '27px', '30px' ],
			fontWeight:    'semibold',
			letterSpacing: 1.5,
		},
	},
	s6: {
		value: {
			fontFamily: 	  'heading',
			fontSize:      [ '16px', '18px' ],
			lineHeight:    [ '24px', '27px' ],
			fontWeight:    'semibold',
			letterSpacing: 1.5,
		},
	},
	p1: {
		value: {
			fontFamily: 	  'body',
			fontSize:      [ '18px', '20px' ],
			lineHeight:    [ '27px', '30px' ],
			fontWeight:    'normal',
			letterSpacing: 0.8,
		},
	},
	p2: {
		value: {
			fontFamily: 	  'body',
			fontSize:      [ '16px', '18px' ],
			lineHeight:    [ '24px', '27px' ],
			fontWeight:    'normal',
			letterSpacing: 0.8,
		},
	},
	p3: {
		value: {
			fontFamily: 	  'body',
			fontSize:      [ '14px', '16px' ],
			lineHeight:    [ '21px', '24px' ],
			fontWeight:    'normal',
			letterSpacing: 0.8,
		},
	},
	p4: {
		value: {
			fontFamily: 	  'body',
			fontSize:      [ '12px', '14px' ],
			lineHeight:    [ '18px', '21px' ],
			fontWeight:    'normal',
			letterSpacing: 0.8,
		},
	},
	p5: {
		value: {
			fontFamily: 	  'body',
			fontSize:      [ '10px', '12px' ],
			lineHeight:    [ '15px', '18px' ],
			fontWeight:    'light',
			letterSpacing: 0.8,
		},
	},
	fieldLabel: {
		value: {
			fontFamily: 	  'body',
			fontSize:      [ '14px', '14px' ],
			lineHeight:    [ '21px', '24px' ],
			fontWeight:    'semibold',
			letterSpacing: 0,
		},
	},
	title: {
		value: {
			fontFamily: 	  'body',
			fontSize:      [ '16px', '18px' ],
			lineHeight:    [ '24px', '27px' ],
			fontWeight:    700,
			letterSpacing: 0,
		},
	},
	price: {
		value: {
			fontFamily: 	  'body',
			fontSize:      [ '18px', '20px' ],
			lineHeight:    [ '27px', '30px' ],
			fontWeight:    800,
			letterSpacing: 0,
		},
	},
});